import React, { Component } from 'react';
import './style.css';
class Line extends Component {
  render() {
    return (
      <div className="line_box">
        
      </div>
    );
  }
}

export default Line;


// WEBPACK FOOTER //
// ./src/components/Line/index.js